import type {ReactElement} from 'react';
import React from 'react';
import {PillButton} from '@Components/pill-button';
import type {StockFilterPillButtonProps} from '../stock-filter-pill-button';

interface StockFilterPillDropdownProps extends StockFilterPillButtonProps {
  filterName: string;
  isMobile?: boolean;
}

export function StockFilterPillDropdown({isMobile = false, ...props}: StockFilterPillDropdownProps): ReactElement<any> | null {
  const selectedSubfilter = props.subfilters.find((subfilter) => {
    return subfilter.id === props.selectedSubfilterID;
  });

  if (selectedSubfilter) {
    return (
      <PillButton
        isSelected
        size={props.pillSize}
        text={selectedSubfilter.text}
        onClick={() => {}}
        onClose={() => {
          props.onSubFilterClicked(props.id);
        }}
      />
    );
  }

  return (
    <PillButton
      size={props.pillSize}
      text={props.filterName}
      onClick={(subFilterID) => {
        props.onSubFilterClicked(props.id, subFilterID);
      }}
      dropDownItems={props.subfilters}
      isMobile={isMobile}
      dropDownClasses={props.className}
    />
  );
}
